module.exports = "/_next/static/images/509fab452477186b21e099502e6e6a15-worldcup-xs-2x.jpg.webp";